import { render, staticRenderFns } from "./BlockTwo.vue?vue&type=template&id=c38f79b0&scoped=true&"
import script from "./BlockTwo.vue?vue&type=script&lang=js&"
export * from "./BlockTwo.vue?vue&type=script&lang=js&"
import style0 from "./BlockTwo.vue?vue&type=style&index=0&id=c38f79b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f79b0",
  null
  
)

export default component.exports